import React, { useState, useEffect } from "react";
import {
    SearchOutlined,
    CheckOutlined,
    CloseOutlined,
    WarningOutlined,
} from "@ant-design/icons";
import {
    Layout,
    Button,
    theme,
    ConfigProvider,
    Input,
    Row,
    Typography,
    Col,
    Card,
    Select,
    Breadcrumb,
    Form,
    DatePicker,
} from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate } from "react-router-dom";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import ContentTop from "../../../components/ContentTop";
import CustomButton from "../../../components/custom/CustomButton";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/MainLayout";
import tableData from "../../../config/data/loanProducts.json"
import TextArea from "antd/es/input/TextArea";
import { QuestionsForm } from "./component/QuestionsForm";

const { Content } = Layout;
const { Text, Title } = Typography;
const Search = Input;

const AddSYA1800 = () => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKey, setSelectedKey] = useState("/sya1800");
    const [switchLabel, setSwitchLabel] = useState("Dark Mode");
    const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
    const [menuBG, setMenuBG] = useState("#2F172D");
    const [searchColorBgContainer, setSearchColorBgContainer] =
        useState("#3B2639");
    const [menuTheme, setMenuTheme] = useState("dark");
    const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
    const [logoDimensions, setLogoDimensions] = useState(100);
    const [menuSearchBarState, setMenuSearchBarState] = useState(false);
    const [menuSearchIconState, setMenuSearchIconState] = useState(true);
    const [switchLabelState, setSwitchLabelState] = useState(false);

    function onSwitchClick() {
        if (switchLabel === "Dark Mode") {
            setSwitchLabel("Light Mode");
            setMenuBG("#fff");
            setSearchColorBgContainer("#f7f8fa");
            setSwitchLabelColor("#8c8f9f");
            setMenuTheme("light");
        } else {
            setSwitchLabelColor("#aeaeae");
            setSwitchLabel("Dark Mode");
            setMenuBG("#2F172D");
            setSearchColorBgContainer("#3B2639");
            setMenuTheme("dark");
        }
    }

    function onMenuSelect(menuItems) {
        // console.log(menuItems.key);
        setSelectedKey(menuItems.key);
        navigate(menuItems.key, { replace: false });
    }

    useEffect(() => {
        if (collapsed === true) {
            setLeftLayoutMargin(71);
            setLogoDimensions(50);
            setMenuSearchBarState(true);
            setMenuSearchIconState(false);
            setSwitchLabelState(true);
        } else {
            setLeftLayoutMargin(190);
            setLogoDimensions(100);
            setMenuSearchBarState(false);
            setMenuSearchIconState(true);
            setSwitchLabelState(false);
        }
    });

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    return (
        <ConfigProvider
            theme={{
                components: {
                    Layout: {
                        siderBg: menuBG,
                    },
                    Menu: {
                        darkItemBg: menuBG,
                        darkSubMenuItemBg: "#241223",
                    },
                },
            }}
        >
            <MainLayout
                collapsed={collapsed}
                searchColorBgContainer={searchColorBgContainer}
                theme={menuTheme}
                defaultSelectedKeys={selectedKey}
                items={menuItems}
                onClick={onMenuSelect}
                switchLabel={switchLabel}
                onSwitchClick={onSwitchClick}
                switchLabelColor={switchLabelColor}
                logoDimensions={logoDimensions}
                menuSearchBarState={menuSearchBarState}
                menuSearchIconState={menuSearchIconState}
                switchLabelState={switchLabelState}
                setCollapsed={setCollapsed}
                leftLayoutMargin={leftLayoutMargin}
                colorBgContainer={colorBgContainer}
            >
                <MainPage titleOfPage={"Add Customer Survey"} />
            </MainLayout>
        </ConfigProvider>
    );
};

const iconMap = {
    Authorised: <CheckOutlined />,
    Unauthorised: <CloseOutlined />,
    Disabled: <WarningOutlined />,
};

function MainPage(props) {
    const [fieldContent, setFieldContent] = useState(<AddSYA1800Form />);
    const navigate = useNavigate();

    function CustType(value) {
        console.log(value);
        if (value === "individual") {
            setFieldContent(<AddSYA1800Form />);
        } else if (value === "company") {
            setFieldContent(<AddSYA1800Form />);
        }
    }

    return (
        <div style={{ marginBottom: 50 }}>
            <ContentTop titleOfPage={"Add Customer Survey"}>
                <BreadcrumbItem>
                    <a href="/dashboard">Home</a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <a href="/sya1800">Customer Survey</a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Text>Add Customer Survey</Text>
                </BreadcrumbItem>
            </ContentTop>
            <div>
                {fieldContent}
            </div>
            <Row gutter={16}></Row>
        </div>
    );
}

function AddSYA1800Form() {

    const [onProceedClick, setOnProceedClick] = useState(false)

    const navigate = useNavigate();

    function onCancel() {
        navigate("/sya1800", { replace: false });
    }

    const onSubmit = (values) => {
        console.log("Success:", values);
    };

    const handleOnProceedClick = () => {
        setOnProceedClick(!onProceedClick)
    }

    return (
        <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>

            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}
            >

                    <Card style={{
                        marginBottom: "2%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                    >
                        <Row style={{ justifyContent: "space-between" }}>

                            <Col span={8}>
                                <Form.Item
                                    name="key"
                                    label={<Text strong>Key</Text>}
                                    rules={[{
                                        required: true,
                                        message: "Required Field"
                                    }]}
                                >
                                    <Input
                                        placeholder="xxxxxxxx"
                                        style={{ width: "30vh" }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="name"
                                    label={<Text strong>Name</Text>}
                                    rules={[{
                                        required: true,
                                        message: "Required Field"
                                    }]}>
                                    <Input
                                        placeholder="xxxxxxxx"
                                        style={{ width: "30vh" }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <div style={{ width: "30vh" }}></div>
                            </Col>
                        </Row>

                        <Row style={{ justifyContent: "space-between" }}>

                            <Col span={8}>
                                <Form.Item
                                    name="countryCode"
                                    label={<Text strong>Country Code</Text>}
                                    rules={[{
                                        required: true,
                                        message: "Required Field"
                                    }]}
                                >
                                    <Input
                                        placeholder="xxxxxxxxx"
                                        style={{ width: "30vh" }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item name="Description" label={<Text strong> description </Text>}>
                                    <TextArea placeholder="Enter description" style={{ width: "45vh", height: "15vh" }} />
                                </Form.Item>

                                <Button
                                    style={{
                                        width: "30%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        color: "ffffff",
                                        backgroundColor: "#15CCAE"

                                    }}
                                    type="primary"
                                    onClick={()=> setOnProceedClick(true)}>Proceed</Button>
                                
                            </Col>

                            <Col span={8}>
                                <div style={{ width: "30vh" }}></div>
                            </Col>
                        </Row>
                    </Card>

                    {onProceedClick && <QuestionsForm handleOnProceedClick={handleOnProceedClick}/>}
                    <Form.Item>
                    <Row>
                        <CustomButton
                            content="Create Survey"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            htmlType="submit"
                            backgroundColor="#15CCAE"
                            colorText="black"
                            hoverBackground="#4FECA0"
                        />
                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "1%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={onCancel}
                        />
                    </Row>
                </Form.Item>
                </Card>
              
        </Form>
    );
}

export default AddSYA1800;
